import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import YMMEEditor from './YMMEEditor'
import LicenceEditor from './LicenceEditor'

const MakeAndModelEditor = ({ changeByLicencePlate, toggleYmme, ...props }) =>
  <Fragment>
    {
      changeByLicencePlate ?
        <LicenceEditor { ...props } handleSwitch={ toggleYmme } /> :
        <YMMEEditor { ...props } handleSwitch={ toggleYmme } />
    }
  </Fragment>

export default MakeAndModelEditor

MakeAndModelEditor.propTypes = {
  changeByLicencePlate: PropTypes.bool,
  toggleYmme: PropTypes.func
}
